// note, this is the priority:
// npm start: .env.development.local, .env.local, .env.development, .env
// npm run build: .env.production.local, .env.local, .env.production, .env
// npm test: .env.test.local, .env.test, .env (note .env.local is missing)
// see more on https://create-react-app.dev/docs/adding-custom-environment-variables

const result_per_page = 10;

const base_api_uri = `${process.env.REACT_APP_qa_server}${process.env.REACT_APP_qa_base_dir}`;
const base_dir = `${process.env.REACT_APP_qa_base_dir}`;
const qa_base = `${process.env.REACT_APP_plone_site}${process.env.REACT_APP_qa_base_dir}`;
const qa_serving_dir = `${process.env.REACT_APP_qa_serving_dir}`;

const _conf =
{
    endpoints:
    {
        qa: qa_base,
        login: `${process.env.REACT_APP_endpoints_login}`,
        main: `${process.env.REACT_APP_qa_server}`,
        userdata: `${base_api_uri}@who-iam`,
        userinfo: `${base_api_uri}@who-is`,
        insertpost: `${base_api_uri}@insert_post`,
        get_best_tags: `${base_api_uri}@tags-best`,
        get_all_tags: `${base_api_uri}@tags-list`,
        get_user_prefs: `${base_api_uri}@notifications-settings`,
        set_user_prefs: `${base_api_uri}@notifications-settings`,
        get_user_schema: `${base_api_uri}@notifications-options`,
        follow_tag: `${base_api_uri}@insert_tag_follower`,

    },
    plone_site: process.env.REACT_APP_plone_site,
    server:
    {
        questions: `${base_dir}@get-questions`,
        answer: `${base_dir}{id}/@related-objects`,
        view_an_answeer: `${base_dir}{id}/@viewed`,
        related: `${base_dir}{id}/@get-similars`,
        followers: `${base_dir}{id}/@get-followers`,
        follow: `${base_dir}{id}/@follow`,
        approve: `${base_dir}{id}/@approve`,
        followed_questions: `${base_dir}{id}/@get-followed-questions`,
        voted_questions: `${base_dir}/@get-voted-questions`,
        approved_questions: `${base_dir}/@get-approved-questions`,
        answered_questions: `${base_dir}/@get-answered-questions`,
        commented_questions: `${base_dir}/@get-commented-questions`,
        main_folder: base_dir
    },
    resources:
    {
        header: process.env.REACT_APP_resources_header,
        footer: process.env.REACT_APP_resources_footer
    },
    route:
    {
        base_without_slash: qa_serving_dir,
        base: `${qa_serving_dir}/`,
        main: `${qa_serving_dir}/questions`,
        answers: `${qa_serving_dir}/questions/:id`,
        answer: `${qa_serving_dir}/questions/`,
        login: `${qa_serving_dir}/login/`,
        ask: `${qa_serving_dir}/questions/ask/`,
        user: `${qa_serving_dir}/user/:id`,
        rules: `${qa_serving_dir}/help/`,
        tags: `${qa_serving_dir}/tags/`,
        tagbyid: `${qa_serving_dir}/tag/:id`,
        root: `${qa_serving_dir}/root`,
        notification: `${qa_serving_dir}/notification`,
        page_not_found: `${qa_serving_dir}/not-found`
    },
    request:
    {
        start: 0,
        stop: result_per_page-1,
        step: result_per_page
    },
    ajax_configuration_object:
    {
        method: 'GET',
        cache: 'no-cache',
        credentials: "include",
        headers:
        {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    },
    DEBUG: (process.env.REACT_APP_DEBUG==='TRUE')
};


export default _conf;